for (let i of document.getElementsByClassName('js-preview-video')) {
    i.addEventListener('click', () => {
        i.querySelector('.js-preview')?.setAttribute('style', 'display: none;')
        const videoElement = i.querySelector('video')
        if(videoElement) {
            videoElement.play()
        }
    })
}
